import { Col, Grid, Image } from "antd";
import { P1, P2, P3 } from "../../../../components/NormalFonts";
import { NewsResponse } from "../../../../hooks/News/data";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import styles from "./styleModule";

type NewsItemProps = {
  article: NewsResponse;
  handleOpenDetail: (articleId: number) => void;
};

const NewsItem: React.FC<NewsItemProps> = ({ article, handleOpenDetail }) => {
  const { toLocalTimezone, formatSmartDate } = useGetTimezone();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  return (
    <Col span={screens.xl ? 6 : screens.sm ? 8 : 24}>
      <div
        onClick={() => handleOpenDetail(article.id)}
        className={styles.articleItemContainer}
      >
        <Image
          preview={false}
          src={article.image_url}
          width={"100%"}
          height={176}
          style={{ objectFit: "cover" }}
        />
        <div className={styles.contentWrapper}>
          <P1 weight="medium" color="var(--text-content-1)">
            {article.title}
          </P1>
          <div className={styles.wrapper}>
            <P2 color="var(--text-content-2)">{article.description}</P2>
          </div>
          <P3 color="var(--text-content-3">
            {formatSmartDate(toLocalTimezone(article.created_at))}
          </P3>
        </div>
      </div>
    </Col>
  );
};

export default NewsItem;
